import React from 'react';
import { Checkbox, Col, Form, Row, Typography, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import { InboxOutlined } from '@ant-design/icons';
import ShowError from 'components/showError';
import FormHelper from 'helpers/FormHelper';
import { Descriptions } from 'antd';

const FileSection = ({ fileReqiuredError }) => {
  const { t } = useTranslation();

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Allegato')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item>
          <Form.Item
            name='file'
            valuePropName='fileList'
            getValueFromEvent={FormHelper.normFile}
            noStyle
            multiple={false}
          >
            <Upload.Dragger
              multiple={false}
              beforeUpload={FormHelper.beforeUpload}
            >
              <p className='ant-upload-drag-icon'>
                <InboxOutlined />
              </p>
              <p className='ant-upload-text'>
                {t('Click or drag file to this area to upload1')}
                'AVI', 'FLV', '3GP', 'WMV', 'MPEG', 'MP4', 'MOV'
                {t('Click or drag file to this area to upload2')}
              </p>
            </Upload.Dragger>
          </Form.Item>
          <Descriptions column={1} bordered>
                  <Descriptions.Item label={`${t('Formati accettati')}:`}>
                  AVI FLV 3GP WMV MPEG MP4 MOV
                  </Descriptions.Item>
          </Descriptions>
        </Form.Item>
        <ShowError errors={fileReqiuredError} />
      </Col>
      <Col offset={6} span={9}>
        <Form.Item valuePropName='checked' name='in_telegram'>
          <Checkbox>{t('Pubblica su telegram')}</Checkbox>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(FileSection);
